import React, { useCallback } from 'react';
import { LobbyBottomNav, BELOT_LOBBY_PLAY_TILES } from './lobbyHubShared';
import { LobbyTablesBlock } from './LobbyTablesBlock';
import { LobbyHomeKataHeading, LobbyHomePlayTilesRow, LobbyHomeTablesModeRow } from './LobbySekaHomeArt';
import { useLobbySekaTables } from '../hooks/useLobbySekaTables';
import { HUB_SOCKET_PHASE } from '../realtime/connectionUx';
import './Lobby.css';

export default function BelotHub({
  user,
  socket,
  hubSocketPhase = HUB_SOCKET_PHASE.IDLE,
  onOpenWallet,
  onOpenBelotGame,
  onOpenOnline,
  onBack,
  onJoinTable,
  onOpenGifts,
  onOpenFriends,
  giftsNavBadgeCount = 0,
  friendsNavBadgeCount = 0,
  onOpenHubJoinOnlineLobby,
  onOpenOnlineCreateRoom,
}) {
  const tableState = useLobbySekaTables({
    socket,
    user,
    onJoinTable,
    lobbyMode: 'belot',
    lobbyReturnView: 'belot',
  });

  const handleModeTileClick = useCallback(
    (tile) => {
      if (tile.id === 'belot-bots') onOpenBelotGame?.();
      else if (tile.id === 'belot-online') onOpenOnline?.();
    },
    [onOpenBelotGame, onOpenOnline]
  );

  return (
    <div className="lobby-mp mx-auto flex min-h-0 w-full max-w-[500px] flex-1 flex-col overflow-x-hidden overflow-y-visible px-3 pt-1.5">
      <div className="lobby-mp-scroll safe-scroll-top min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-1 pb-[var(--lobby-bottom-nav-h)] pt-0.5 [scroll-padding-bottom:var(--lobby-bottom-nav-h)] sm:px-1.5">
        <LobbyHomeKataHeading />
        <LobbyHomeTablesModeRow initialMode="belot" onSelectSeka={onBack} onOpenBelot={() => {}} />
        <LobbyHomePlayTilesRow
          socket={socket}
          tiles={BELOT_LOBBY_PLAY_TILES}
          onTileClick={handleModeTileClick}
        />

        <LobbyTablesBlock
          mode="belot"
          toolbarVisual="homeArt"
          user={user}
          onJoinTable={onJoinTable}
          onPlayThroughOnlineLobby={
            onOpenHubJoinOnlineLobby
              ? (table) =>
                  onOpenHubJoinOnlineLobby({
                    roomCode: String(table?.id ?? '')
                      .trim()
                      .toUpperCase(),
                    isPrivate: Boolean(table?.isPrivate),
                    origin: 'belot',
                  })
              : undefined
          }
          hubSocketPhase={hubSocketPhase}
          onOpenCreateRoom={() => onOpenOnlineCreateRoom?.()}
          {...tableState}
        />
      </div>

      <LobbyBottomNav
        mode="belot"
        visual="homeArt"
        onOpenGifts={onOpenGifts}
        onOpenFriends={onOpenFriends}
        onOpenCreateRoom={() => onOpenOnlineCreateRoom?.()}
        giftsNavBadgeCount={giftsNavBadgeCount}
        friendsNavBadgeCount={friendsNavBadgeCount}
      />
    </div>
  );
}
